{
  "altitude": {
    "displayName": "Altitud",
    "unitLabel": {
      "metric": "metro",
      "us": "pie"
    }
  },
  "applicationRateEstimatedMm": {
    "displayName": "Solicitud"
  },
  "applicationRateReportsMm": {
    "displayName": "Solicitud",
    "unitLabel": {
      "metric": "mm",
      "us": "en"
    }
  },
  "calibrationIntercept": {
    "displayName": "Intersección de calibración"
  },
  "calibrationSlope": {
    "displayName": "Pendiente de calibración"
  },
  "configurationId": {
    "displayName": "ID de configuración"
  },
  "currentPercentage": {
    "displayName": "Porcentaje actual"
  },
  "deviceFunctionCall": {
    "displayName": "Llamada a la función del dispositivo"
  },
  "deviceFunctionCallId": {
    "displayName": "causaId"
  },
  "diameterMm": {
    "displayName": "Diámetro de la rueda",
    "instructions": "Mida el diámetro (distancia más ancha entre dos lados de la rueda).",
    "unitLabel": {
      "metric": "mm",
      "us": "en"
    }
  },
  "distanceObservedMm": {
    "displayName": "Distancia",
    "unitLabel": {
      "metric": "metro",
      "us": "pie"
    }
  },
  "flowRateEstimatedLpm": {
    "displayName": "Caudal",
    "unitLabel": {
      "metric": "litros por minuto",
      "us": "galón/min"
    }
  },
  "gpsType": {
    "displayName": "Modelo de chip GPS"
  },
  "heading": {
    "displayName": "Título",
    "unitLabel": "°"
  },
  "hoseWheelMmPerMagnet": {
    "displayName": "Distance Per Magnet",
    "description": "The distance of hose travel for each magnet reading on the hose wheel sensor.",
    "unitLabel": {
      "metric": "mm",
      "us": "in"
    }
  },
  "hoseDiameterMm": {
    "displayName": "Diámetro de la manguera",
    "images": {
      "hose_diameter.png": {
        "caption": "Asegúrese de medir la manguera en su punto más ancho."
      }
    },
    "instructions": {
      "1": "Mida con la mayor precisión posible el diámetro de la manguera del carrete.",
      "2": "Asegúrese de medir la manguera en su punto más ancho. En la imagen de abajo, el granjero usa sus dedos índices para encontrar el punto más ancho de la manguera y usa la cinta métrica para marcar la línea."
    },
    "unitLabel": {
      "metric": "mm",
      "us": "pulgadas"
    }
  },
  "i2cAddress": {
    "displayName": "Dirección I2C"
  },
  "installedOrientation": {
    "displayName": "Orientación instalada"
  },
  "internalSoc": {
    "displayName": "Batería interna SoC",
    "unitLabel": "%"
  },
  "ioPin": {
    "displayName": "Pin de E/S"
  },
  "linearSpeedMmHMax": {
    "displayName": "Velocidad máxima de retracción"
  },
  "linearSpeedMmHMin": {
    "displayName": "Velocidad mínima de retracción"
  },
  "location": {
    "displayName": "Ubicación"
  },
  "maxTrackingPercentage": {
    "displayName": "Porcentaje máximo de seguimiento"
  },
  "milliRpmAvg": {
    "displayName": "RPM",
    "unitLabel": "RPM"
  },
  "milliRpmFast": {
    "displayName": "Umbral de velocidad (superior)",
    "unitLabel": "RPM"
  },
  "milliRpmSlow": {
    "displayName": "Umbral de velocidad (inferior)",
    "unitLabel": "RPM"
  },
  "minTrackingPercentage": {
    "displayName": "Porcentaje mínimo de seguimiento"
  },
  "mlPerPulse": {
    "displayName": "Volumen por pulso",
    "unitLabel": {
      "metric": {
        "long": "Litros",
        "short": "yo"
      },
      "us": "galón"
    }
  },
  "nMagnets": {
    "description": "¿Cuántos imanes se instalan en el carrete? En el caso de los carretes, deben ser entre 8 y 16.",
    "displayName": "Número de imanes instalados",
    "images": {
      "magnet_installation_positions.png": {
        "caption": "Instalación estándar de 16 imanes"
      }
    },
    "optionLabel": "Imanes"
  },
  "nNozzles": {
    "description": "¿Cuántas boquillas utiliza el carrete para suministrar agua?",
    "displayName": "Número de boquillas",
    "images": {
      "irrigation_boom.png": {
        "caption": "Una pluma con 12 boquillas."
      },
      "irrigation_gun.png": {
        "caption": "Un carrete de pistola con una sola boquilla."
      }
    }
  },
  "nSats": {
    "displayName": "Calidad de la señal"
  },
  "nWrapsOuterLayer": {
    "description": "Cuando la manguera está completamente enrollada alrededor del carrete, ¿cuántas vueltas son visibles en la capa más externa?",
    "displayName": "Número de vueltas de la capa exterior",
    "images": {
      "reel_outer_hose_wraps.png": {
        "caption": "Un carrete con 9 vueltas de capa exterior.\n\nTenga en cuenta que solo las vueltas de manguera a la izquierda y a la derecha de la 9.ª vuelta no se cuentan, aunque son visibles porque no están en la capa exterior."
      }
    }
  },
  "flowRateOverrideLpm": {
    "displayName": "Anulación de caudal",
    "description": "Cuando se establece, este caudal medido se usa directamente para los cálculos del historial de riego en lugar de estimarlo a partir del diámetro de la boquilla y la presión.",
    "instructionsWithUnitLabel": "Introduzca el caudal medido en {{unitLabel}}, o déjelo en blanco para usar la estimación basada en el diámetro de la boquilla.",
    "unitLabel": {
      "metric": {
        "long": "litros por minuto",
        "short": "L/min"
      },
      "us": {
        "long": "galones por minuto",
        "short": "gal/min"
      }
    }
  },
  "nozzleDiameterMm": {
    "displayName": "Diámetro de la boquilla",
    "images": {
      "nozzle_diameter.png": {
        "altText": "Fotografía anotada que ilustra la trayectoria de medición del diámetro de la boquilla.",
        "caption": "Asegúrese de medir la abertura de la boquilla en su punto más ancho."
      }
    },
    "instructionsWithUnitLabel": "Mida el ancho interior de la boquilla en {{unitLabel}}",
    "note": "Asegúrese de medir la abertura de la boquilla en su punto más ancho.",
    "unitLabel": {
      "metric": {
        "long": "milímetros",
        "short": "mm"
      },
      "us": {
        "long": "pulgadas",
        "short": "en"
      }
    }
  },
  "otaEnabled": {
    "displayName": "OTA habilitado"
  },
  "outerHoseWrapRadiusMm": {
    "description": "El radio de envoltura exterior de la manguera es la distancia desde el centro del carrete hasta el borde exterior de la manguera cuando está completamente envuelta.",
    "displayName": "Radio de envoltura de la manguera exterior",
    "images": {
      "reel_outer_hose_wraps.png": {
        "altText": "Diagrama de medición del radio de envoltura de la manguera exterior."
      }
    },
    "instructions": {
      "introduction": "Para determinar esta medida, realice una de las siguientes acciones:",
      "options": {
        "1": "Si puede determinar fácilmente dónde caería el borde exterior de la manguera en el lado que mira hacia afuera del carrete (ver imagen a continuación), mida la distancia entre el centro del eje del carrete y la ubicación relativa del borde de la manguera.",
        "2": "Otra opción es mirar dentro del carrete y medir la distancia desde el borde exterior del carrete hasta el comienzo de la manguera. Restar esta distancia de la distancia entre el borde del carrete y el eje del carrete."
      }
    },
    "unitLabel": {
      "metric": "mm",
      "us": "en"
    }
  },
  "pidDerivativeCoeff": {
    "displayName": "Coeficiente derivado PID"
  },
  "pidGainCoeff": {
    "displayName": "Coeficiente de ganancia PID"
  },
  "pidIntegralCoeff": {
    "displayName": "Coeficiente integral PID"
  },
  "pidSensorSetpoint": {
    "displayName": "Punto de ajuste del sensor PID"
  },
  "pivotRadiusMeters": {
    "displayName": "Radio de pivote",
    "unitLabel": {
      "metric": "Metros",
      "us": "Pies"
    }
  },
  "pressureObservedKpa": {
    "displayName": "Presión",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "pressureReportsKpa": {
    "displayName": "Presión",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "rampSecondsRemaining": {
    "displayName": "Segundos restantes"
  },
  "rampSecondsTotal": {
    "displayName": "Total de segundos"
  },
  "rateLpmAvg": {
    "displayName": "Caudal medio",
    "unitLabel": {
      "metric": "litros por minuto",
      "us": "galón/min"
    }
  },
  "rateLpmMax": {
    "displayName": "Caudal máximo",
    "unitLabel": {
      "metric": "litros por minuto",
      "us": "galón/min"
    }
  },
  "rateLpmMin": {
    "displayName": "Caudal mínimo",
    "unitLabel": {
      "metric": "litros por minuto",
      "us": "galón/min"
    }
  },
  "readingCelsius": {
    "displayName": "Temperatura",
    "unitLabel": {
      "metric": "C°",
      "us": "F°"
    }
  },
  "readingKpa": {
    "displayName": "Presión",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "reportingPeriodEndDt": {
    "displayName": "Fin del período de informe"
  },
  "reportingPeriodStartDt": {
    "displayName": "Inicio del período de informe"
  },
  "relativePercentage": {
    "displayName": "Porcentaje relativo (%)",
    "unitLabel": {
      "metric": "%",
      "us": "%"
    }
  },
  "runDistanceMmCurrent": {
    "displayName": "Distancia restante",
    "unitLabel": {
      "metric": "metro",
      "us": "pie"
    }
  },
  "runDistanceMmElapsed": {
    "displayName": "Distancia transcurrida",
    "unitLabel": {
      "metric": "metro",
      "us": "pie"
    }
  },
  "runDistanceMmMax": {
    "displayName": "Distancia extendida",
    "unitLabel": {
      "metric": "metro",
      "us": "pie"
    }
  },
  "runMagnetCountCurrent": {
    "displayName": "Corriente de recuento de imanes"
  },
  "runMagnetCountMax": {
    "displayName": "Cantidad máxima de imanes"
  },
  "runSpeedMmpm": {
    "displayName": "Velocidad de carrera",
    "unitLabel": {
      "metric": "m/hora",
      "us": "pies/hora"
    }
  },
  "scheduledDeviceAction": {
    "displayName": "Acción programada del dispositivo"
  },
  "sensorModelId": {
    "displayName": "Modelo de sensor"
  },
  "sensorPort": {
    "description": "Los sensores de carrete, presión, rueda y flujo se pueden instalar en uno de los puertos de sensores de un dispositivo FarmHQ (solo generaciones FC2 y TC3).",
    "displayName": "Puerto de sensor",
    "displayNameWithVal": "Puerto {{val}}",
    "fieldLabelWithSensorName": "Puerto del sensor {{sensorName}}",
    "images": {
      "enclosure_front.png": {
        "caption": "Puertos de sensor 1 (centro izquierda) y 2 (centro derecha) en un gabinete FarmHQ FC2."
      }
    },
    "values": {
      "port-1": "Puerto 1",
      "port-2": "Puerto 2"
    }
  },
  "sensorPriority": {
    "displayName": "Prioridad del sensor"
  },
  "sensorTriggeredUpdate": {
    "displayName": "Actualización activada por sensor"
  },
  "signalQuality": {
    "displayName": "Calidad de la señal"
  },
  "signalStrength": {
    "displayName": "Intensidad de la señal"
  },
  "speedMillirpm": {
    "displayName": "Velocidad rotacional",
    "unitLabel": "RPM"
  },
  "speedMmpm": {
    "displayName": "Velocidad",
    "unitLabel": {
      "metric": "m/hora",
      "us": "pies/hora"
    }
  },
  "speedObservedMmpm": {
    "displayName": "Velocidad",
    "unitLabel": {
      "metric": "m/hora",
      "us": "pies/hora"
    }
  },
  "speedReportsMmpm": {
    "displayName": "Velocidad",
    "unitLabel": {
      "metric": "m/hora",
      "us": "pies/hora"
    }
  },
  "speedMeasurementMethod": {
    "displayName": "Speed Measurement Method",
    "description": "Choose how reel speed is measured. 'Spool Rotation' calculates speed from spool geometry. 'Hose Wheel' measures the hose directly as it passes a sensor wheel.",
    "values": {
      "spool_rotation": "Spool Rotation",
      "hose_wheel": "Hose Wheel"
    }
  },
  "applicationType": {
    "displayName": "Tipo de aplicación",
    "description": "Lo que este carrete aplica al campo. Cada pasada del carrete se anota con este tipo. El valor predeterminado es agua.",
    "values": {
      "water": "Agua",
      "manure": "Purín",
      "other": "Otro"
    }
  },
  "sprinklerType": {
    "description": "Al seleccionar “Pistola”, se agregarán tapas de extremo semicirculares a las franjas en el Mapa de estado del dispositivo y en la página Historial de riego de campo.",
    "displayName": "Tipo de aspersor",
    "values": {
      "boom": "Auge",
      "gun": "Pistola"
    }
  },
  "startRampPercentage": {
    "displayName": "Porcentaje de inicio"
  },
  "stateCurrent": {
    "displayName": "Estado actual"
  },
  "stateCurrentInitDt": {
    "displayName": "Último cambio de estado"
  },
  "statePrevious": {
    "displayName": "Estado anterior"
  },
  "statePreviousInitDt": {
    "displayName": "Cambio de estado anterior"
  },
  "stoppedTimeoutMs": {
    "displayName": "Tiempo de espera de rueda detenida",
    "description": "Cuánto tiempo espera el dispositivo sin detectar movimiento de la rueda antes de reportar la rueda como detenida.",
    "unitLabel": "min"
  },
  "swathWidthMm": {
    "descriptionWithUnitLabel": "Una estimación del ancho de una fila en {{unitLabel}}. En el caso de los carretes para pistolas, esto también duplica la distancia a la que se rocía el agua con la pistola.",
    "displayName": "Ancho de franja",
    "placeholder": "Introduzca el ancho de la franja",
    "unitLabel": {
      "metric": "metro",
      "us": "pie"
    }
  },
  "switchType": {
    "helpBodyText": "La configuración predeterminada del interruptor indica si el interruptor está normalmente abierto o normalmente cerrado.\n\nSi no está seguro, comuníquese con el servicio de asistencia de FarmHQ.",
    "displayName": "Configuración del interruptor predeterminada",
    "values": {
      "C": "cerrado",
      "O": "abierto"
    }
  },
  "targetRampPercentage": {
    "displayName": "Porcentaje objetivo"
  },
  "threshold": {
    "displayName": "Límite",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdPsiLower": {
    "descriptionWithValue": "Cualquier valor por debajo de {{value}} es demasiado bajo.",
    "displayName": "Umbral inferior",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "thresholdPsiUpper": {
    "descriptionWithValue": "Cualquier valor superior a {{value}} es demasiado alto.",
    "displayName": "Umbral superior",
    "unitLabel": {
      "metric": "kPa",
      "us": "psi"
    }
  },
  "voltageChangeMvPerHour": {
    "displayName": "Cambio de voltaje"
  },
  "voltageIntercept": {
    "displayName": "Intercepción de voltaje"
  },
  "voltageMv": {
    "displayName": "Voltaje",
    "unitLabel": "V"
  },
  "voltageSlope": {
    "displayName": "Pendiente de voltaje"
  },
  "voltageThresholdLowMv": {
    "displayName": "Umbral de voltaje inferior",
    "unitLabel": "Voltios"
  },
  "volumeLFinal": {
    "displayName": "Volumen final",
    "unitLabel": {
      "metric": "yo",
      "us": "galón"
    }
  },
  "volumeLInitial": {
    "displayName": "Volumen inicial",
    "unitLabel": {
      "metric": "yo",
      "us": "galón"
    }
  },
  "volumeLTotal": {
    "displayName": "Volumen total",
    "unitLabel": {
      "metric": "yo",
      "us": "galón"
    }
  },
  "widthMm": {
    "displayName": "Ancho del carrete",
    "images": {
      "reel_width.png": {
        "caption": "Diagrama del ancho del carrete."
      }
    },
    "instructions": "Mida la distancia entre las paredes del carrete.",
    "unitLabel": {
      "metric": "mm",
      "us": "en"
    }
  }
}
